import { render, staticRenderFns } from "./RoomTestbankExamTable.vue?vue&type=template&id=8957991a&scoped=true&"
import script from "./RoomTestbankExamTable.vue?vue&type=script&lang=js&"
export * from "./RoomTestbankExamTable.vue?vue&type=script&lang=js&"
import style0 from "./RoomTestbankExamTable.vue?vue&type=style&index=0&id=8957991a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8957991a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8957991a')) {
      api.createRecord('8957991a', component.options)
    } else {
      api.reload('8957991a', component.options)
    }
    module.hot.accept("./RoomTestbankExamTable.vue?vue&type=template&id=8957991a&scoped=true&", function () {
      api.rerender('8957991a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/Testbank/Exam/RoomTestbankExamTable.vue"
export default component.exports